import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15 0H1v4H0v1.2h1v3.2H0v1.2h1v3.2H0V14h1v4h14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM9.004 4.786c1.098 0 1.551.889 1.551 1.841 0 .916-.463 1.937-1.551 1.937-1.106 0-1.56-.995-1.56-1.937 0-.96.463-1.841 1.56-1.841zM5 13l.804-1.989c.088-.217.212-.419.376-.588a3.503 3.503 0 0 1 1.457-.892l1.368 1.368 1.366-1.366a3.497 3.497 0 0 1 1.45.89c.163.168.288.37.376.588L13 13H5z" />
  </svg>
);

export default SvgComponent;
